import moment from 'moment';

import { Api } from 'src/models/Api.model';
import { CriteriaGroupGroupElementsInnerOperatorEnum } from 'src/models/GalenData/CriteriaGroupGroupElementsInner.model';
import { DeviceDataView } from 'src/models/GalenData/DeviceDataView.model';
import { EntityCriteriaOperatorEnum } from 'src/models/GalenData/EntityCriteria.model';
import { OrderData, OrderStatusEnum } from 'src/models/GalenData/Order.model';
import { IGetUsersRequestBody } from 'src/models/GalenData/Request.model';
import {
  GalenDataUser,
  GalenDataUserColumn,
} from 'src/models/GalenData/User.model';

export interface PatientMatchData {
  id?: string;
  dob?: string;
  firstName?: string;
  lastName?: string;
}

export interface MatchResult {
  matchedPatient?: GalenDataUser;
  openOrder?: DeviceDataView<OrderData>;
}

const getMatchedPatient = async (
  data: PatientMatchData,
): Promise<GalenDataUser[]> => {
  const filterConditions: {
    key: keyof (GalenDataUserColumn & IGetUsersRequestBody);
    value: string | undefined;
  }[] = [
    { key: 'patientId', value: data.id?.trim() },
    {
      key: 'dateOfBirth',
      value: data.dob ? moment(data.dob).format('YYYY-MM-DD') : undefined,
    },
    { key: 'firstName', value: data.firstName?.trim() },
    { key: 'lastName', value: data.lastName?.trim() },
  ];

  const filters = filterConditions
    .filter(({ value }) => value)
    .map(({ key, value }) => ({
      key,
      value,
      operator: EntityCriteriaOperatorEnum.Equal,
    }));

  const response = await Api.remote._get_users_advanced(filters);

  return response.data.content || [];
};

export const getMatchedPatientWithOpenOrder = async (
  data: PatientMatchData,
): Promise<MatchResult> => {
  const matchedPatients = await getMatchedPatient(data);
  const patient = matchedPatients[0];

  if (!patient) {
    return {};
  }

  const openOrder = await Api.remote.get_exam_order({
    ownerFilter: {
      users: [patient.userId],
    },
    groupElements: [
      {
        key: 'Status',
        value: OrderStatusEnum.OPEN,
        operator: CriteriaGroupGroupElementsInnerOperatorEnum.Equal,
      },
    ],
  });

  return {
    matchedPatient: patient,
    openOrder: openOrder.data.content?.[0],
  };
};
